<template>
  <div>
    <v-card class="py-3 mb-4">
      <v-card-title>
        <span class="title">
          {{ $t('reports.providerPriceComparison.title') }}
        </span>
      </v-card-title>
      <v-card-subtitle>
        <span class="subheading">
          {{ $t('reports.providerPriceComparison.description') }}
        </span>
      </v-card-subtitle>
      <v-card-text>
        <span class="body-2">
          {{ $t('reports.providerPriceComparison.chooseProvider') }}
        </span>
        <div class="d-flex justify-center">
          <v-autocomplete
            v-model="selectedProvider"
            :label="$t('reports.providerPriceComparison.providers')"
            :items="this.providers"
            return-object
          />
        </div>
      </v-card-text>
      <v-card-actions class="d-flex align-center justify-center">
        <v-btn @click="download" color="primary darken-1" :disabled="!canContinue">
          {{ loading ? $t('reports.downloading') : $t('reports.download') }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :color="snackBarColor" :timeout="3000">
      <span class="body-1">
        {{ snackbarText }}
      </span>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'ProviderPriceComparison',
  data () {
    return {
      loading: false,
      snackbar: false,
      snackbarText: '',
      snackBarColor: null,
      selectedProvider: null,
      providers: []
    }
  },
  computed: {
    restaurant () {
      return this.$store.state.currentRestaurant.data
    },
    canContinue () {
      return this.selectedProvider !== null
    }
  },
  async mounted () {
    await this.loadProviders()
  },
  methods: {
    showSnackBar (message, success) {
      this.snackBarColor = success ? 'success darken-1' : 'error darken-1'
      this.snackbarText = message
      this.snackbar = true
    },
    async loadProviders () {
      try {
        this.providers = await this.$api.get(`/v1/restaurants/${this.restaurant._id}/reports/providers`)
      } catch (error) {
        this.showSnackBar(error.message, false)
      }
    },
    downloadFile (response) {
      const link = document.createElement('a')
      const restaurantName = this.restaurant.name.toLowerCase().replace(' ', '-')
      const fileName = `reporte-${restaurantName}-${this.selectedProvider[0]}.xlsx`
      link.href = 'data:application/octet-stream;base64,' + response
      link.download = fileName
      link.click()
      this.loading = false
    },
    async download () {
      this.loading = true
      try {
        const response = await this.$api.post(`/v1/restaurants/${this.restaurant._id}/reports/provider-price-comparison`, {
          providerName: this.selectedProvider
        })
        this.downloadFile(response)
        this.showSnackBar(this.$t('reports.successfulDownload'), true)
      } catch (error) {
        this.showSnackBar(error.message, false)
      }
    }
  }
}
</script>
